import React, { useEffect } from 'react'
import { IPageComponentProps } from '../features/router/Interfaces'
import ProtectedRoute from '../features/router/ProtectedRoute'
import QuickNotification from '../features/notifications/QuickNotification'
import GlobalPreloader from '../components/GlobalPreloader'
import { Helmet } from "react-helmet";
import ApplicationConfig from '../config'
import { useLocation } from 'react-router-dom'
import DarkModeWrapper from '../features/router/DarkModeWrapper'
import QuickElementPreview from '../components/QuickElementPreview'

export default function BasePage(props: IPageComponentProps) {

    const { title } = props.page
    const location = useLocation()

    const helmet = () => {
        return(
            <Helmet>
                <title>{title} - {ApplicationConfig.appName}</title>
            </Helmet>
        )
    }

    const scrollToTop = (): void => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
    }

    useEffect(() => {
        scrollToTop()
    }, [location.pathname])

    if (props.page.isProtected){
        return(
            <DarkModeWrapper>
                {helmet()}
                <QuickElementPreview />
                <QuickNotification />
                <GlobalPreloader />
                <ProtectedRoute {...props} />
            </DarkModeWrapper>
        )
    }

    return(
        <DarkModeWrapper>
            {helmet()}
            <QuickNotification />
            <QuickElementPreview />
            <GlobalPreloader />
            <props.page.component page={props.page} />
        </DarkModeWrapper>
    )
}